import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import { tzNormalizeDate } from '../../../../utils/date';
import { INT_DATE_FORMAT } from '../../../../config/locale';
import TableToolbar from '../../../common/TableToolbar';
import { ADMINISTRATIVE_CHECKLIST_PATH, NEW_ADMINISTRATIVE_CHECKLIST_PATH } from '../../../../config/paths';
import Table from '../../../common/Table';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import IncidentsSearchForm from './IncidentsSearchForm';
import { ADMINISTRATIVE_CHECKLIST_COLUMNS } from '../../../../config/columns';
import {
  clearAdministrativeIncidents,
  getAdministrativeIncidents,
} from '../../../../actions/supervision-control';

const AdministrativeChecklists = ({
  breadcrumbs,
  dispatchGetAdministrativeIncidents,
  dispatchClearAdministrativeIncidents,
  administrativeIncidents,
  loading,
}) => {

  useLayoutEffect(
    () => () => {
      dispatchClearAdministrativeIncidents();
    },
    [],
  );

  const handleSubmit = (formValues) => {
    const newFormValues = {
      dateString: tzNormalizeDate({
        date: formValues.dateString,
        format: INT_DATE_FORMAT,
      }),
      agencyId: formValues.agency ? formValues.agency.value : null,
    };
    dispatchGetAdministrativeIncidents(newFormValues);
  };

  const content = (
    <>
      <IncidentsSearchForm
        onSubmit={handleSubmit}
        initialValues={{
          dateString: tzNormalizeDate(),
        }}
        loading={false}
      />
      <Table
        columns={ADMINISTRATIVE_CHECKLIST_COLUMNS}
        data={administrativeIncidents}
        pages={DEFAULT_PAGE_SIZE}
        manual={false}
        loading={loading}
        filterable
        navigateToModelOnRowClick
        isExternalPath
        modelPath={ADMINISTRATIVE_CHECKLIST_PATH}
      />
    </>
  );

  const toolBar = (
    <TableToolbar
      buttonPath={NEW_ADMINISTRATIVE_CHECKLIST_PATH}
      buttonText="Nuevo"
      icon="fa fa-plus-circle"
    />
  );

  return (
    <Content
      title="Checklist Administrativo"
      content={content}
      breadcrumbs={breadcrumbs}
      toolbar={toolBar}
    />
  );
};

AdministrativeChecklists.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetAdministrativeIncidents: PropTypes.func.isRequired,
  dispatchClearAdministrativeIncidents: PropTypes.func.isRequired,
  administrativeIncidents: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loading: PropTypes.bool.isRequired,
};

AdministrativeChecklists.defaultProps = {};

const mapStateToProps = ({ SupervisionControlUnit }) => ({
  breadcrumbs: [
    ...SupervisionControlUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Checklist Administrativo',
      href: '',
    },
  ],
  administrativeIncidents: SupervisionControlUnit.AdministrativeIncident.getIn([
    'administrativeIncidents',
    'content',
    'content',
  ]),
  loading: SupervisionControlUnit.AdministrativeIncident.getIn([
    'administrativeIncidents',
    'loading',
  ]),
});

const mapDispatchToProps = {
  dispatchGetAdministrativeIncidents: getAdministrativeIncidents,
  dispatchClearAdministrativeIncidents: clearAdministrativeIncidents,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdministrativeChecklists);
